import styled from "styled-components";
const Div = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  form {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  div {
    margin: 5px;
  }
  button{
    margin: 10px;
  }
`;
export default Div;
